import geolib from 'geolib';

export const DISTANCE_THROTTLE = 50;

let calculateDistance = (from,  to) => {
    return geolib.getDistance(from, to);
};

export const allowGeoChange = (currentPos, nextPos) => {
    let distance = calculateDistance(
        {
            latitude : currentPos.latitude,
            longitude: currentPos.longitude
        },
        {
            latitude : nextPos.latitude,
            longitude: nextPos.longitude
        }
    );

    return (distance >= DISTANCE_THROTTLE);
};

export const triggerRequired = (currentPos, nextPos) =>
{
    let distance = calculateDistance(
        {
            latitude : currentPos.latitude,
            longitude: currentPos.longitude
        },
        {
            latitude : nextPos.coords.lat,
            longitude: nextPos.coords.long
        }
    );

    return (distance <= nextPos.triggerRadius);
};



// WEBPACK FOOTER //
// ./src/classes/GeoThrottle.js